export const COLUMN_AUTOMATIONS_COPY = {
  menuLabel: "Automations",
  addLabel: "Add automation",
  addHint: "Choose a trigger and an action.",
  pickerTitle: "Add automation",
  pickerDescription: "Choose an automation for this column.",
  sourceTaken: "This automation is already configured.",
  needsRepairLabel: "Needs repair",
  disabledLabel: "Disabled",
  editLabel: "Edit automation",
  tabsLabel: "Automation sections",
  generalTab: "General",
  agentTab: "Agent",
  automationTab: "Automation",
  viewLoading: "The automation is loading.",
  viewEmpty: "This automation has no steps yet.",
  viewError: "SuperPlane could not load the automation.",
  viewRetry: "Try again",
  rowsEmpty: "No automations",
  rowMenu: "Open automation",
  deleteLabel: "Delete automation",
  deletingLabel: "Deleting",
  keepLabel: "Keep automation",
  confirmDelete: "Delete this automation? This cannot be undone.",
  viewMenuLabel: "Board view",
  viewOptions: "View options",
  viewAutomations: "Automations",
  viewNames: "Names",
  viewIcons: "Icons",
  viewColumnColors: "Column colors",
  viewColorVivid: "Vivid",
  viewColorSoft: "Soft",
  viewColorBorders: "Bordered",
  viewColorOff: "None",
  lastRunPassed: "Passed",
  lastRunFailed: "Failed",
  activityRunning: "running",
} as const;
